<ng-container *ngIf="vm$ | async as vm">
  <div class="flex-container">
    <div class="flex-row strategy-header">
      <div class="flex-col-auto">
        <span>{{ 'new_strategy.navigation.step' | translate }} 1</span>
        <h1 class="ui-headline">{{ 'new_strategy.impact_screen.h2' | translate }}</h1>
        <p [innerHtml]="'new_strategy.impact_screen.pAmount' | translate"></p>
        <div class="strategy-topic-explanations">
          <p (click)="trackActivity('[Link] Handprint read more')">
            <strong>{{ 'new_strategy.portfolio_screen.topics_box.handprint' | translate }}: </strong>
            <span [innerHtml]="'new_strategy.impact_screen.p_hand' | translate"></span>
          </p>
          <p (click)="trackActivity('[Link] Footprint read more')">
            <strong>{{ 'new_strategy.portfolio_screen.topics_box.footprint' | translate }}: </strong>
            <span [innerHtml]="'new_strategy.impact_screen.p_foot' | translate"></span>
          </p>
          <p (click)="trackActivity('[Link] Exclusions read more')">
            <strong>{{ 'new_strategy.impact_screen.h3_exc' | translate }}: </strong>
            <span [innerHtml]="'new_strategy.impact_screen.p_exc' | translate"></span>
          </p>
        </div>
      </div>
    </div>

    <div class="flex-row strategy-topic-header">
      <div class="flex-col-auto">
        <h3 class="ui-headline">{{ 'new_strategy.impact_screen.h3_hand' | translate }}</h3>
      </div>
    </div>

    <div class="flex-row handTopics">
      <div class="flex-col-2 flex-col-md-3 flex-col-sm-6 flex-col-xs-6" *ngFor="let topic of vm.handTopics">
        <app-strategy-topics-card
          [showSampleCompanies]="true"
          [selected]="isSelectedCard(vm.selectedIds.selectedHandTopics, topic.id)"
          [card]="topic"
          (click)="selectCard($event, vm.selectedIds.selectedHandTopics, topic.id, vm.originalIds, vm.selectedIds)"
        ></app-strategy-topics-card>
      </div>
    </div>

    <div class="flex-row strategy-topic-header">
      <div class="flex-col-auto">
        <h3 class="ui-headline">{{ 'new_strategy.impact_screen.h3_foot' | translate }}</h3>
      </div>
    </div>

    <div class="flex-row footTopics">
      <div class="flex-col-2 flex-col-md-3 flex-col-sm-6 flex-col-xs-6" *ngFor="let topic of vm.footTopics">
        <app-strategy-topics-card
          [showSampleCompanies]="true"
          [selected]="isSelectedCard(vm.selectedIds.selectedFootTopics, topic.id)"
          [card]="topic"
          (click)="selectCard($event, vm.selectedIds.selectedFootTopics, topic.id, vm.originalIds, vm.selectedIds)"
        ></app-strategy-topics-card>
      </div>
    </div>

    <div class="flex-row strategy-topic-header">
      <div class="flex-col-auto">
        <h3 class="ui-headline">{{ 'new_strategy.impact_screen.h3_exc' | translate }}</h3>
      </div>
    </div>

    <div class="flex-row criteria">
      <div class="flex-col-2 flex-col-md-3 flex-col-sm-6 flex-col-xs-6" *ngFor="let criterium of vm.criteria">
        <app-strategy-topics-card
          [showSampleCompanies]="true"
          [selected]="isSelectedCard(vm.selectedIds.selectedCriteria, criterium.id)"
          [card]="criterium"
          (click)="selectCard($event, vm.selectedIds.selectedCriteria, criterium.id, vm.originalIds, vm.selectedIds)"
        ></app-strategy-topics-card>
      </div>
    </div>
  </div>

  <ng-container *ngIf="vm.currentAccount.step_status !== 5 && !is3aPillar">
    <div class="flex-row xs-only sm-only">
      <div class="flex-col-auto">
        <div class="strategy-footer-protected topic-mobile">
          <app-guarantee-shield (guaranteeModal)="toggleGuaranteeModal()"></app-guarantee-shield>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="vm.currentAccount.step_status !== 5 && is3aPillar">
    <div class="flex-row xs-only sm-only">
      <div class="flex-col-auto">
        <img class="shield" src="/assets/images/shield-liberty.svg" alt="shield" />
        <p [innerHTML]="'protected-3a' | translate"></p>
      </div>
    </div>
  </ng-container>

  <app-footer [hideGuarantee]="false">
    <ng-container *ngIf="vm.currentAccount.step_status !== 1 && wasChanged(vm.originalIds, vm.selectedIds)">
      <button (click)="cancelChanges()" class="ui-button secondary" [disabled]="isLoading$ | async">
        {{ 'new_strategy.save_mode.cancel' | translate }}
      </button>
      <button (click)="send(true, vm.selectedIds)" class="ui-button" [class.loading]="isLoading$ | async">
        <span class="icon-i-windmill"></span>
        {{ 'new_strategy.save_mode.cta' | translate }}
      </button>
    </ng-container>
    <ng-container *ngIf="vm.currentAccount.step_status !== 1 && !wasChanged(vm.originalIds, vm.selectedIds)">
      <button (click)="cancelChanges()" class="ui-button">
        {{ 'new_strategy.portfolio_screen.back_cta' | translate }}
      </button>
    </ng-container>
    <ng-container *ngIf="vm.currentAccount.step_status === 1">
      <button (click)="send(false, vm.selectedIds)" class="ui-button" [class.loading]="isLoading$ | async">
        <span class="icon-i-windmill"></span>
        {{ 'new_strategy.investment_screen.cta' | translate }}
      </button>
    </ng-container>
  </app-footer>

  <app-strategy-was-changed-modal
    (saveChangesEmitter)="send($event, vm.selectedIds)"
    (discardChangesEmitter)="discardChanges($event, vm.originalIds, vm.selectedIds)"
    [stepStatus]="vm.currentAccount.step_status"
    [qlOnboardingStep]="vm.currentAccount.ql_onboarding_step"
  ></app-strategy-was-changed-modal>
</ng-container>
